// extracted by mini-css-extract-plugin
module.exports = {"formBox":"FormSection_formBox__TIbyW","contentBox":"FormSection_contentBox__SKvn8","mainWrapper":"FormSection_mainWrapper__HuSJR"};